import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { LiveShiftBoard } from '../components/LiveShiftBoard';
import { SavingsEstimator } from '../components/SavingsEstimator';
import { TrustSection } from '../components/TrustSection';
import { StickyFooter } from '../components/StickyFooter';
import { MobileBottomNav } from '../components/MobileBottomNav';
import { ServicesSection } from '../components/ServicesSection';
export function Home() {
  return <div className="min-h-screen w-full bg-white" data-id="element-1052">
      {/* Navigation */}
      <Navbar data-id="element-1053" />

      {/* Main content */}
      <main data-id="element-1054">
        {/* Hero: compact mobile-first with multi-step widget */}
        <HeroSection data-id="element-1055" />

        {/* Dual-navigation services: Hire Now grid + Care Solutions menu */}
        <ServicesSection data-id="element-1056" />

        {/* How it works: quick 3-step explainer */}
        <HowItWorks data-id="element-1057" />

        {/* Live shift availability board */}
        <LiveShiftBoard data-id="element-1058" />

        {/* Savings estimator — immediately after marketplace feed */}
        <SavingsEstimator data-id="element-1059" />

        {/* Trust: Proudly Canadian & Nurse-Owned */}
        <TrustSection data-id="element-1060" />

        {/* FAQ section */}
        <FAQSection data-id="element-1061" />
      </main>

      {/* Footer with sticky app download CTAs */}
      <StickyFooter data-id="element-1062" />

      {/* Mobile bottom navigation */}
      <MobileBottomNav data-id="element-1063" />

      {/* Spacer for sticky footer on desktop */}
      <div className="hidden md:block h-14" aria-hidden="true" data-id="element-1064" />
      {/* Spacer for mobile bottom nav */}
      <div className="md:hidden h-16" aria-hidden="true" data-id="element-1065" />
    </div>;
}
function HowItWorks() {
  return <section className="w-full bg-white py-16 border-b border-gray-100" aria-label="How Care Nomad works" data-id="element-1066">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1067">
        <div className="text-center mb-12" data-id="element-1068">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-text-dark tracking-tight mb-3" data-id="element-1069">
            Solutions in <span className="text-medical-blue" data-id="element-1070">Minutes</span>, Not
            Days
          </h2>
          <p className="text-text-muted text-lg" data-id="element-1071">
            Three simple steps to access staffing, care, or virtual support
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-1072">
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute top-10 left-1/3 right-1/3 h-0.5 bg-soft-teal" aria-hidden="true" data-id="element-1073" />

          {/* Step 1 */}
          <div className="text-center group" data-id="element-1074">
            <div className="relative w-24 h-24 mx-auto mb-5" data-id="element-1075">
              <div className="w-20 h-20 bg-soft-teal rounded-2xl flex items-center justify-center mx-auto relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-1076">
                <span className="text-3xl font-extrabold text-medical-blue" data-id="element-1077">
                  1
                </span>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-medical-blue rounded-full flex items-center justify-center" data-id="element-1078">
                  <span className="text-white text-xs font-bold" data-id="element-1079">✓</span>
                </div>
              </div>
              <div className="absolute inset-0 bg-medical-blue/5 rounded-full blur-xl group-hover:bg-medical-blue/10 transition-colors" data-id="element-1080" />
            </div>
            <h3 className="font-bold text-text-dark text-lg mb-2" data-id="element-1081">
              Select Your Service
            </h3>
            <p className="text-text-muted text-sm leading-relaxed px-4" data-id="element-1082">
              Choose between Staffing, Home Care, or Virtual Assistant services.
              Enter your details and requirements in under 60 seconds.
            </p>
          </div>

          {/* Step 2 */}
          <div className="text-center group" data-id="element-1083">
            <div className="relative w-24 h-24 mx-auto mb-5" data-id="element-1084">
              <div className="w-20 h-20 bg-soft-teal rounded-2xl flex items-center justify-center mx-auto relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-1085">
                <span className="text-3xl font-extrabold text-medical-blue" data-id="element-1086">
                  2
                </span>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-accent-teal rounded-full flex items-center justify-center" data-id="element-1087">
                  <span className="text-white text-xs" data-id="element-1088">⚡</span>
                </div>
              </div>
              <div className="absolute inset-0 bg-accent-teal/5 rounded-full blur-xl group-hover:bg-accent-teal/10 transition-colors" data-id="element-1089" />
            </div>
            <h3 className="font-bold text-text-dark text-lg mb-2" data-id="element-1090">
              Get Matched Instantly
            </h3>
            <p className="text-text-muted text-sm leading-relaxed px-4" data-id="element-1091">
              Our algorithm matches you with nurse-vetted workers or expert
              assistants. Review profiles and credentials before confirming.
            </p>
          </div>

          {/* Step 3 */}
          <div className="text-center group" data-id="element-1092">
            <div className="relative w-24 h-24 mx-auto mb-5" data-id="element-1093">
              <div className="w-20 h-20 bg-soft-teal rounded-2xl flex items-center justify-center mx-auto relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-1094">
                <span className="text-3xl font-extrabold text-medical-blue" data-id="element-1095">
                  3
                </span>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-accent-teal rounded-full flex items-center justify-center" data-id="element-1096">
                  <span className="text-white text-xs" data-id="element-1097">🍁</span>
                </div>
              </div>
              <div className="absolute inset-0 bg-medical-blue/5 rounded-full blur-xl group-hover:bg-medical-blue/10 transition-colors" data-id="element-1098" />
            </div>
            <h3 className="font-bold text-text-dark text-lg mb-2" data-id="element-1099">
              Service Commences
            </h3>
            <p className="text-text-muted text-sm leading-relaxed px-4" data-id="element-1100">
              Care begins or support starts. Everything is tracked in-app,
              ensuring quality and transparency from start to finish.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
type FAQItem = {
  question: string;
  answer: string;
};
const FAQ_ITEMS: FAQItem[] = [{
  question: 'What services does Care Nomad provide?',
  answer: 'We provide a comprehensive ecosystem: Healthcare Staffing (RN, RPN, PSW), Home Care Solutions (In-home nursing, dementia care), and Virtual Assistant services for facility operations.'
}, {
  question: 'How quickly can I get a worker or assistant placed?',
  answer: 'Our average match time is 4 minutes. Whether you need an emergency shift covered or a virtual assistant to start immediately, our platform is built for speed.'
}, {
  question: 'How are the virtual assistants vetted?',
  answer: 'Just like our clinical staff, virtual assistants undergo rigorous vetting. They are trained in healthcare operations, compliance, and privacy standards (HIPAA/PHIPA).'
}, {
  question: 'Can I use Care Nomad for private home care?',
  answer: 'Yes! Our "Care Solutions" tab is specifically designed for families seeking professional, nurse-supervised care in the comfort of their own homes.'
}, {
  question: 'Is Care Nomad available across Canada?',
  answer: "We currently serve Ontario, British Columbia, and Alberta for all service lines. We're expanding to additional provinces in 2025."
}];
function FAQSection() {
  return <section className="w-full bg-white py-16 lg:py-24" aria-label="Frequently asked questions" data-id="element-1101">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1102">
        <div className="text-center mb-12" data-id="element-1103">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-text-dark tracking-tight mb-3" data-id="element-1104">
            Frequently Asked Questions
          </h2>
          <p className="text-text-muted text-lg" data-id="element-1105">
            Everything you need to know about Care Nomad
          </p>
        </div>

        <div className="space-y-4" data-id="element-1106">
          <FAQAccordion items={FAQ_ITEMS} data-id="element-1107" />
        </div>

        <div className="mt-10 text-center bg-soft-teal rounded-2xl p-8" data-id="element-1108">
          <h3 className="font-bold text-text-dark text-xl mb-2" data-id="element-1109">
            Still have questions?
          </h3>
          <p className="text-text-muted text-sm mb-5" data-id="element-1110">
            Our team is available 24/7 to help you get started
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-1111">
            <a href="tel:+18005551234" className="bg-medical-blue text-white font-bold px-6 py-3 rounded-xl hover:bg-medical-blue-dark transition-colors text-sm" data-id="element-1112">
              📞 Call 1-800-555-1234
            </a>
            <a href="#" className="bg-white text-medical-blue font-bold px-6 py-3 rounded-xl border-2 border-medical-blue hover:bg-soft-teal transition-colors text-sm" data-id="element-1113">
              💬 Live Chat
            </a>
          </div>
        </div>
      </div>
    </section>;
}
function FAQAccordion({
  items
}: {
  items: FAQItem[];
}) {
  return <>
      {items.map((item, index) => <FAQItem key={index} item={item} data-id="element-1114" />)}
    </>;
}
function FAQItem({
  item
}: {
  item: FAQItem;
}) {
  return <details className="group bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-1115">
      <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none hover:bg-soft-teal transition-colors" data-id="element-1116">
        <span className="font-semibold text-text-dark text-sm pr-4" data-id="element-1117">
          {item.question}
        </span>
        <span className="text-medical-blue text-xl font-light flex-shrink-0 group-open:rotate-45 transition-transform duration-200" data-id="element-1118">
          +
        </span>
      </summary>
      <div className="px-6 pb-5 pt-1" data-id="element-1119">
        <p className="text-text-muted text-sm leading-relaxed" data-id="element-1120">{item.answer}</p>
      </div>
    </details>;
}